import React from 'react';
import { MapPin, Mail, Phone, MessageCircle } from 'lucide-react';
export function ContactSection() {
  return <section id="contacto" className="py-16 md:py-24 bg-white" data-id="element-13">
      <div className="container mx-auto px-4 md:px-6" data-id="element-14">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-15">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-16">
            {/* Contact Info */}
            <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-17">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#1B2B5E]" data-id="element-18">
                ¿Listo para enviar tus compras?
              </h2>
              <p className="text-lg text-gray-600 mb-10" data-id="element-19">
                Contáctanos hoy y recibe tu cotización
              </p>

              <div className="space-y-8 mb-12" data-id="element-20">
                <div className="flex items-start gap-4" data-id="element-21">
                  <div className="w-12 h-12 bg-[#F8F9FA] rounded-full flex items-center justify-center flex-shrink-0 text-[#1B2B5E]" data-id="element-22">
                    <MapPin size={24} data-id="element-23" />
                  </div>
                  <div data-id="element-24">
                    <h4 className="font-bold text-[#1B2B5E] mb-1" data-id="element-25">Dirección</h4>
                    <p className="text-gray-600" data-id="element-26">
                      7763 NW 64 St, Miami, FL 33166
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-27">
                  <div className="w-12 h-12 bg-[#F8F9FA] rounded-full flex items-center justify-center flex-shrink-0 text-[#1B2B5E]" data-id="element-28">
                    <Phone size={24} data-id="element-29" />
                  </div>
                  <div data-id="element-30">
                    <h4 className="font-bold text-[#1B2B5E] mb-1" data-id="element-31">Teléfono</h4>
                    <p className="text-gray-600" data-id="element-32">+58 414 1594413</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-33">
                  <div className="w-12 h-12 bg-[#F8F9FA] rounded-full flex items-center justify-center flex-shrink-0 text-[#1B2B5E]" data-id="element-34">
                    <Mail size={24} data-id="element-35" />
                  </div>
                  <div data-id="element-36">
                    <h4 className="font-bold text-[#1B2B5E] mb-1" data-id="element-37">
                      Correo Electrónico
                    </h4>
                    <p className="text-gray-600" data-id="element-38">info@laspalmascargo.com</p>
                  </div>
                </div>
              </div>

              <a href="https://wa.link/o50a7n" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-[#20bd5a] transition-colors shadow-lg shadow-[#25D366]/30 w-full sm:w-auto" data-id="element-39">
                <MessageCircle size={24} data-id="element-40" />
                Escríbenos por WhatsApp
              </a>
            </div>

            {/* Image Side */}
            <div className="relative h-64 lg:h-auto" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/khivWFqPupy4cyYvvKuxeR/Concepto_familia.jpg" alt="Familia recibiendo paquete" className="absolute inset-0 w-full h-full object-cover" data-id="element-42" />
              <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-transparent lg:w-1/3 hidden lg:block" data-id="element-43"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}